import React, {useEffect, useState} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import BaseModal from "./BaseModal";
import activeModalState from "../../state/ui/activeModalState";
import FormControl from "../FormControl";
import playerState from "../../state/ui/playerState";
import Tooltip from "../Tooltip";
import windowDimensionState from "../../state/ui/windowDimensionState";
import { useTranslation } from "react-i18next";

export default function VideoSettingModal() {
  const {t} = useTranslation('lounge')
  const windowDimensions = useRecoilValue(windowDimensionState);
  const [activeModal, setShowModal] = useRecoilState(activeModalState);
  const player = useRecoilValue(playerState);

  const [disabled, setDisabled] = useState(false);
  const [value, setValue] = useState();
  const [trackValue, setTrackValue] = useState();

  const isMobileView = windowDimensions.width < 768;

  useEffect(() => {
    setValue(player.selectedQuality || '');
  },[player.selectedQuality]);

  useEffect(() => {
    setTrackValue(player.selectedTrack || '');
  },[player.selectedTrack]);

  return (
    <BaseModal show={activeModal === 'video-setting'} title={t('video-settings')} showTitle>
      <div className="w-full">
        <div className="flex flex-row flex-wrap justify-between">
            <div className="flex-1 flex mr-2">
              <button
                className={`btn-setting ${player.muted ? 'bg-gray-200 icon-muted' : 'bg-green-500'}`}
                onClick={() => {
                if(player.muted) {
                    window?.SpacePlayer?.unmute && window.SpacePlayer.unmute();
                }
                else {
                    window?.SpacePlayer?.mute && window.SpacePlayer.mute();
                }
                !isMobileView && closeModal();
                }}
              >
                <img src="/images/space/icon-sound.png"
                    className={`icon-setting ${player.muted ? 'filter invert' : ''}`}
                    draggable="false"></img>
              </button>
            </div>
            <div className="flex-1 flex">
                <button
                    className="btn-setting bg-gray-200"
                    onClick={() => {
                        // closeModal();
                        window?.SpacePlayer?.requestFullscreen && window.SpacePlayer.requestFullscreen();
                    }}
                >
                    <img src="/images/space/icon-fullscreen.png" className="icon-setting filter invert"
                        draggable="false"></img>
                </button>
            </div>

        </div>

        <div className="w-full border-t my-3"></div>

        {window?.SpacePlayer?.setQuality && window?.SpacePlayer?.setTrack && 
          <>
            <FormControl.Select
                light
                label={t('video-quality')}
                className="mb-2"
                options={player.qualities ? player.qualities.map(item => ({value: item.id, label: item.label})) : []}
                onChange={(e) => {
                  setValue(e.target.value);
                }}
                value={value}
                disabled={disabled}
                key={'video-quality'}
            />
            <FormControl.Select
              light
              label={t('video-captions')}
              className="mb-2"
              options={player.tracks ? player.tracks.map(item => ({value: item.id, label: item.label})) : []}
              onChange={(e) => {
                setTrackValue(e.target.value);
              }}
              value={trackValue}
              disabled={disabled}
              key={'video-captions'}
            />
            <div>
              <button
                  type={'submit'}
                  onClick={async () => {
                    setDisabled(true);
                    if(value != player.selectedQuality && window.SpacePlayer?.setQuality) {
                      await window.SpacePlayer.setQuality(value)
                    }
                    if(trackValue != player.selectedTrack && window.SpacePlayer?.setTrack) {
                      await window.SpacePlayer.setTrack(trackValue)
                    }
                    setDisabled(false);
                  }}
                  disabled={disabled}
                  className="btn-primary">
                  {t('update')}
              </button>
          </div>
          </>
        }
      </div>
    </BaseModal>
  )
}
